import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=260bd00e&scoped=true&"
import script from "./Thanks.vue?vue&type=script&lang=js&"
export * from "./Thanks.vue?vue&type=script&lang=js&"
import style0 from "./Thanks.vue?vue&type=style&index=0&id=260bd00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260bd00e",
  null
  
)

export default component.exports